import React, { memo } from "react";
import { Box } from "@mui/material";
import DynamicColumnsTable from "./DynamicColumnsTable";

const COLLATERAL_ROWS = [
  { label: "Предмет залога (указать: ценные бумаги, недвижимость, оборудование, автотранспорт, ТМЦ)", field: "pledgeSubject" },
  { label: "Описание предмета залога (наименование, состав, натуральная форма, ассортимент, и т.п.)", field: "pledgeDescription" },
  { label: "Наименование залогодателя, ИНН", field: "pledgorNameInn" },
  { label: "Документы, подтверждающие право собственности на имущество, переданное Банку в залог", field: "ownershipDocuments" },
  { label: "Местонахождение (адрес, договор аренды) и условия хранения залога", field: "locationAndStorage" },
  { label: "Результаты проверки залога", field: "verificationResults" },
  { label: "Рыночная стоимость залога", field: "marketValue" },
  { label: "Справедливая стоимость залога", field: "fairValue" },
  { label: "Дисконт", field: "discount" },
  { label: "Залоговая стоимость", field: "pledgeValue" },
  { label: "Порядок определения справедливой стоимости и данные, на основании которых сделан вывод (источники получения информации, сравнительные объекты, их идентификационные данные и т.п.)", field: "fairValueDetermination" },
  { label: "Сведения об обременении имущества (обязательствами перед третьими лицами, в том числе по действующим кредитным договорам и договорам залога имущества в Банке)", field: "encumbranceInfo", type: "select", options: ["Имущество не обременено", "Имущество обременено"] },
  { label: "Расчет необходимой стоимости обеспечения", field: null },
  { label: "Сумма кредита", field: "creditAmount" },
  { label: "Сумма процентов за весь срок действия кредитного договора", field: "interestAmount" },
  { label: "Сумма комиссий (при наличии)", field: "commissionAmount" },
  { label: "ИТОГО", field: "total", calculated: true },
  { label: "Покрытие залогом суммы кредита, процентов и комиссии (при наличии), %", field: "coveragePercentage" },
  { label: "Анализ возможности реализации залога", field: "realizationAnalysis", type: "select", options: ["Реализация залога возможна в течение ____ (календарных дней)", "Отсутствуют документально подтвержденные обстоятельства, которые могут существенно препятствовать реализации Банком прав, вытекающих из наличия обеспечения по кредиту", "Реализация залога невозможна"], inputTrigger: "Реализация залога возможна в течение ____ (календарных дней)" },
  { label: "Оценка категории качества обеспечения в соответствии с главой 6 Положения № 590-П", field: "qualityCategoryAssessment", type: "select", options: ["Не относится к I или II категории", "I категория качества", "II категория качества"] },
  { label: "Формирование РВПС с учетом обеспечения", field: "rvpsFormation" },
  { label: "Предмет залога может быть реализован в срок, не превышающий 365 календарных дней со дня возникновения основания для обращения взыскания на залог", field: "realizableIn365Days", type: "select", options: ["Может", "Не может"] },
  { label: "Возникновение у Банка оснований для признания невозможности реализовать права, вытекающие из наличия обеспечения по ссуде, без существенных потерь суммы (стоимости) обеспечения, при условии, что юридическая документация в отношении залоговых прав Банка оформлена таким образом, что в ней не содержится условий, препятствующих реализации залоговых прав и (или) предмета залога", field: "bankRightsImpossibility", type: "select", options: ["Может", "Не может"] },
  { label: "Вывод о формировании РВПС с учетом залогового обеспечения", field: "rvpsConclusion", type: "select", options: ["РВПС формируется без учета обеспечения", "РВПС формируется с учетом обеспечения"] },
  { label: "Страхование предмета залога", field: "pledgeInsurance", type: "select", options: ["Не применяется", "Применяется"] },
];

const PLEDGOR_ROWS = [
  { label: "Полное наименование залогодателя в соответствии с учредительными документами", field: "fullName" },
  { label: "ИНН", field: "inn" },
  { label: "Адрес в соответствии с учредительными документами (по данным ЕГРЮЛ или ЕГРИП)", field: "registeredAddress" },
  { label: "Адрес фактического местонахождения", field: "actualAddress" },
  { label: "Оценка финансового положения залогодателя", field: "financialAssessment" },
  { label: "По результатам формализованной оценки финансового положения на основании анализа структуры баланса и основных финансовых коэффициентов финансовое положение залогодателя оценивается как", field: "formalAssessmentResult", type: "select", options: ["Хорошее", "Среднее", "Плохое"] },
  { label: "Негативная информация в отношении залогодателя", field: "negativeInfo", type: "select", options: ["Не выявлена", "Выявлена"] },
];

const GUARANTOR_ROWS = [
  { label: "Наименование поручителя", field: "guarantorName" },
  { label: "ИНН", field: "inn" },
  { label: "Адрес фактического местонахождения", field: "actualAddress" },
  { label: "Номер расчетного счета в Банке / дата открытия", field: "bankAccountNumber" },
  { label: "Оценка финансового положения поручителя", field: "financialAssessment" },
  { label: "По результатам формализованной оценки финансового положения на основании анализа структуры баланса и основных финансовых коэффициентов финансовое положение залогодателя оценивается как:", field: "formalAssessmentResult", type: "select", options: ["Хорошее", "Среднее", "Плохое"] },
  { label: "Негативная информация в отношении залогодателя:", field: "negativeInfo", type: "select", options: ["Не выявлена", "Выявлена"] },
  { label: "Сумма указанного обеспечения", field: "securityAmount" },
  { label: "Покрытие указанным обеспечением общего размера требований по кредитному договору (договорам)", field: "coverageAmount" },
  { label: "Вывод о возможности принятия указанного обеспечения", field: "acceptanceConclusion" },
  { label: "Оценка категории качества обеспечения в соответствии с главой 6 Положения № 590-П", field: "qualityCategoryAssessment", type: "select", options: ["Не относится к I или II категории", "I категория качества", "II категория качества"] },
  { label: "Вывод о возможности формирования РВПС с учетом обеспечения", field: "rvpsConclusion", type: "select", options: ["РВПС формируется без учета обеспечения", "РВПС формируется с учетом обеспечения"] },
];

const parseNum = (v) => {
  const n = parseFloat(String(v).replace(/\s/g, "").replace(",", "."));
  return isNaN(n) ? 0 : n;
};

const getCalculatedValue = (item) => {
  const sum =
    parseNum(item.creditAmount) +
    parseNum(item.interestAmount) +
    parseNum(item.commissionAmount);
  return sum === 0 ? "" : sum.toString();
};

const CollateralTabComponent = ({
  collateralItems, onItemChange, onAddColumn, onDeleteColumn,
  pledgorItems = [], onPledgorChange, onPledgorAdd, onPledgorDelete,
  guarantorItems = [], onGuarantorChange, onGuarantorAdd, onGuarantorDelete,
}) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
    <DynamicColumnsTable
      title="Залог имущества"
      columnLabel={(index) => `Залог ${index + 1}`}
      rows={COLLATERAL_ROWS}
      items={collateralItems}
      onItemChange={onItemChange}
      onAddColumn={onAddColumn}
      onDeleteColumn={onDeleteColumn}
      getCalculatedValue={getCalculatedValue}
    />
    <DynamicColumnsTable
      title="Информация о залогодателе юридическом лице"
      columnLabel={(index) => `Залогодатель ${index + 1}`}
      rows={PLEDGOR_ROWS}
      items={pledgorItems}
      onItemChange={onPledgorChange}
      onAddColumn={onPledgorAdd}
      onDeleteColumn={onPledgorDelete}
    />
    <DynamicColumnsTable
      title="Иные виды обеспечения: поручительство юридического лица"
      columnLabel={(index) => `Поручитель ${index + 1}`}
      rows={GUARANTOR_ROWS}
      items={guarantorItems}
      onItemChange={onGuarantorChange}
      onAddColumn={onGuarantorAdd}
      onDeleteColumn={onGuarantorDelete}
    />
  </Box>
);

const CollateralTab = memo(CollateralTabComponent);

export default CollateralTab;